<!-- @format -->
<section
	id="pdp-selector-attributes"
	class="selector-attributes-container">
	<pdp-attributes-components-label [attributeGroupName]="labelAttrGroupName()">
	</pdp-attributes-components-label>
	<div class="hmf-grid hmf-mb-xs hmf-pt-xs hmf-pt-m-0 selector-attribute-outer">
		<ng-container
			*ngFor="
				let attributesOption of selectorAttributeData();
				let j = index;
				trackBy: trackByFn
			">
			<hmf-selector
				class="hmf-mr-xs"
				[color]="attributesOption.value"
				[selected]="checkForIsSelected(attributesOption)"
				[disabled]="
					!(selectDisabledAttributes$ | async)[attributesOption?.name].includes(
						attributesOption?.value
					)
				"
				(click)="selectedAttribute(attributesOption)"
				(keydown.enter)="selectedAttribute(attributesOption)"
				(keydown.space)="selectedAttribute(attributesOption)"
				[dblBorder]="true"
				selector="circular"
				circleVariant="xsmall"
				[ariaLabel]="attributesOption.value">
			</hmf-selector>
		</ng-container>
	</div>
</section>
